// ============================================================
// Tutorial NPC script — edit this file to change what the bot
// says during the "how to play" walkthrough.
//
// CHAT_SCRIPT entries appear one by one as chat messages.
// "delay" is milliseconds after the previous message before
// this one types and appears. Keep messages short and punchy.
// ============================================================

export const NPC_NAME = "trustbot";

// Shown on the intro screen before the chat starts
export const INTRO_LINES = [
  "i'll be your practice partner",
  "this round doesn't count — it's just to show you how the game works",
];

// Scripted chat messages, played in order
export const CHAT_SCRIPT = [
  { delay: 600,  text: "hey! welcome to trust game." },
  { delay: 2400, text: "every day you get matched with a real stranger." },
  { delay: 2200, text: "you chat for 3 minutes — about anything you like." },
  { delay: 2400, text: "then, secretly and at the same time, you each make a choice:" },
  { delay: 2000, text: "trust — or betray." },
  { delay: 2200, text: "if you BOTH trust → you both earn 3 points. 🤝" },
  { delay: 2200, text: "if you BOTH betray → you both earn 1 point. 😬" },
  { delay: 2400, text: "if one of you trusts and the other betrays → the betrayer gets 5 points, the trusting player gets 0. 🗡️" },
  { delay: 2600, text: "so the real question is: can you read someone in just 3 minutes?" },
  { delay: 2400, text: "ok — i've made up my mind. now it's your turn 👇" },
];

// What the NPC says while the user is deciding (above the trust/betray buttons)
export const DECISION_PROMPT = "time to choose. what do you do?";

// Message shown after user picks, before the reveal
export const POST_CHOICE_MESSAGE = "interesting choice... let's see what i picked.";

// What the NPC says after the outcome is revealed (optional flavour text)
export const OUTRO_LINES = {
  both_trust: "see? when both players trust each other, everyone wins more. but that requires courage.",
  both_betray: "mutual betrayal is the safe play — but you both lose out on the bigger reward.",
  i_trust_they_betray: "ouch. you trusted, i didn't. in the real game, this is the risk you take.",
  i_betray_they_trust: "you betrayed me! in the real game, that's a bold call. worth it? that depends on your conscience.",
};
